// Generates dummy data to simulate drone 
export function generateFakeTelemetry() {
  return {
    ts: Date.now(),
    alt: 10 + Math.random() * 2,
    yaw: Math.random() * 360,
    bat_pct: Math.floor(80 + Math.random() * 20),
    link: Math.floor(70 + Math.random() * 30),
    mode: 'AUTO',
    wind_est: Math.floor(Math.random() * 5),
    payload_state: 'OFF',
    failsafe: Math.random() > 0.95 ? 'ENGAGED' : 'OK'
  };
}
